import { createFileRoute } from '@tanstack/react-router';
import Shopcart from '../../components/client/Shopcart';
import ClientPortal from '../../components/portals/ClientPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockUser } from '../../data/mockData';

export const Route = createFileRoute('/client/shopcart')({
  component: ClientShopcartRoute,
});

function ClientShopcartRoute() {
  const { user, isManager } = useAuth();
  const content = <Shopcart user={user && !isManager ? user : mockUser} />;
  return <ClientPortal>{content}</ClientPortal>;
}
